import React from 'react';
import { motion } from 'framer-motion';
import { Shield, XCircle, CheckCircle2 } from 'lucide-react';
export function BlindajeComparison() {
  const comparison = [{
    sit: 'Tu vivienda ante una demanda futura',
    sin: 'Vulnerable a embargo',
    con: 'Inscribís el Bien de Familia y la protegés'
  }, {
    sit: 'Un banco te bloquea la cuenta',
    sin: 'Te quedás a pie',
    con: 'Sistema de 3 cuentas en bancos diferentes'
  }, {
    sit: 'Perdés tu empleo de golpe',
    sin: 'Crisis financiera inmediata',
    con: 'Fondo de Blindaje cubre 3-6 meses'
  }, {
    sit: 'Tu único ingreso se corta',
    sin: 'Catástrofe económica',
    con: 'Ya tenés 2-3 fuentes de ingreso diversificadas'
  }, {
    sit: 'La inflación come tus ahorros',
    sin: 'Dinero pierde valor en pesos',
    con: 'Capital en UI e instrumentos protegidos'
  }, {
    sit: 'Abuso de empresa o acreedor',
    sin: 'No sabés cómo defenderte',
    con: 'Modelos legales listos para actuar'
  }];
  const modules = [{
    icon: '🛡️',
    title: 'Módulo 1 — Escudo de Activos',
    desc: 'Cómo inscribir el Bien de Familia. Proceso paso a paso.'
  }, {
    icon: '🏦',
    title: 'Módulo 2 — Ingeniería de Cuentas',
    desc: 'El sistema de 3 cuentas en bancos diferentes.'
  }, {
    icon: '💰',
    title: 'Módulo 3 — Multiplicadores de Ingreso',
    desc: 'Las mejores fuentes de Ingreso B y C para Uruguay.'
  }, {
    icon: '📈',
    title: 'Módulo 4 — Inversión Segura en Uruguay',
    desc: 'UI, LRM, Consorcios Ganaderos. Tu dinero creciendo.'
  }, {
    icon: '⚖️',
    title: 'Módulo 5 — Defensa Legal Preventiva',
    desc: 'Contratos, Derecho de Retracto, carta de eliminación.'
  }];
  return <section className="py-12 md:py-20 px-4 bg-brand-dark" data-id="element-22">
      <div className="max-w-4xl mx-auto" data-id="element-23">
        <div className="text-center mb-12" data-id="element-24">
          <Shield className="w-12 h-12 text-gold mx-auto mb-4" data-id="element-25" />
          <h2 className="text-2xl md:text-3xl font-black text-white mb-4" data-id="element-26">
            ¿Qué Agrega el "Método PRO: Blindaje Financiero Total"?
          </h2>
        </div>

        {/* Comparison Table Mobile (Stacked) & Desktop (Grid) */}
        <div className="mb-16" data-id="element-27">
          <div className="hidden md:grid grid-cols-3 gap-4 mb-4 px-4 text-sm font-bold text-gold uppercase tracking-wider text-center" data-id="element-28">
            <div className="text-left" data-id="element-29">Tu Situación</div>
            <div className="text-red-400" data-id="element-30">❌ Sin Blindaje PRO</div>
            <div className="text-brand-success" data-id="element-31">✅ Con Blindaje PRO</div>
          </div>

          <div className="space-y-4" data-id="element-32">
            {comparison.map((row, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-brand-green border border-gold/10 rounded-xl p-4 md:p-0 md:grid md:grid-cols-3 md:gap-4 md:items-center overflow-hidden" data-id="element-33">
                <div className="md:p-4 font-medium text-white mb-3 md:mb-0" data-id="element-34">
                  {row.sit}
                </div>

                <div className="flex items-start gap-2 md:p-4 md:bg-red-950/20 md:h-full mb-2 md:mb-0" data-id="element-35">
                  <XCircle className="w-5 h-5 text-red-500 shrink-0 md:hidden" data-id="element-36" />
                  <span className="text-cream/70 text-sm" data-id="element-37">{row.sin}</span>
                </div>

                <div className="flex items-start gap-2 md:p-4 md:bg-brand-success/10 md:h-full" data-id="element-38">
                  <CheckCircle2 className="w-5 h-5 text-brand-success shrink-0 md:hidden" data-id="element-39" />
                  <span className="text-gold font-medium text-sm" data-id="element-40">
                    {row.con}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Modules List */}
        <div className="bg-brand-light border border-gold/30 rounded-2xl p-6 md:p-8 shadow-gold-glow" data-id="element-41">
          <div className="space-y-6" data-id="element-42">
            {modules.map((mod, i) => <div key={i} className="flex items-start gap-4" data-id="element-43">
                <div className="text-2xl" data-id="element-44">{mod.icon}</div>
                <div data-id="element-45">
                  <h4 className="text-white font-bold mb-1" data-id="element-46">{mod.title}</h4>
                  <p className="text-cream/80 text-sm" data-id="element-47">{mod.desc}</p>
                </div>
              </div>)}
            <div className="pt-4 border-t border-gold/20 flex items-center gap-3" data-id="element-48">
              <span className="text-2xl" data-id="element-49">📋</span>
              <h4 className="text-gold font-bold" data-id="element-50">
                Plan Maestro de 12 Meses + Checklist Blindaje Total
              </h4>
            </div>
          </div>
        </div>
      </div>
    </section>;
}